import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Home from '../views/Home'
import Welcome from '../views/Welcome'
import Categories from '../views/commodity/Categories'
import CategoriesList from '../views/commodity/CategoriesList'
import AddCategories from '../views/commodity/AddCategories'
import Order from '../views/order/Order.vue'
import Audit from '../views/Audit.vue'
import bossHome from '../views/bossHome'
import BussinessOrder from '../views/BussinessOrder'
import addressList from '../views/addressManage/addressList'
import addAddress from '../views/addressManage/addAddress'
import addImg from '../views/productImg/addImg'
import imgList from '../views/productImg/imgList'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', redirect: '/Login' },
    { path: '/Login', component: Login },
    {
    path: '/Home',
    component: Home,
    redirect: '/Welcome',
    children: [
        { path: '/Welcome', component: Welcome },
        { path: '/Categories', component: Categories },
        { path: '/CategoriesList', component: CategoriesList },
        { path: '/AddCategories', component: AddCategories },
        { path: '/Order', component: Order },
        { path: '/addressList', name: 'addressList', component: addressList }, // wt addAddress
        { path: '/addAddress', component: addAddress }, // wt
        { path: '/Audit', component: Audit },
        { path: '/BussinessOrder', component: BussinessOrder },
        { path: '/imgList', component: imgList },
        { path: '/addImg', component: addImg }
    ]
    },
    {
    path: '/bossHome',
    component: bossHome,
    redirect: '/Audit',
    children: [
        { path: '/Audit', component: Audit },
        { path: '/BussinessOrder', name: 'BussinessOrder', component: BussinessOrder }
    ]
    }
]
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/Login') return next()
  // 获取token
  const constStr = window.sessionStorage.getItem('token')
  // 如果token未登录,无法进入其他页面
  if (!constStr) return next('/Login')
  next()
})

export default router
